var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 3C6.25 2.58579 6.58579 2.25 7 2.25H17.3889C18.5251 2.25 19.6043 2.58031 20.415 3.23831C21.2398 3.90776 21.75 4.89029 21.75 6.08203V17C21.75 17.4142 21.4142 17.75 21 17.75C20.5858 17.75 20.25 17.4142 20.25 17V6.08203C20.25 5.35278 19.9518 4.7943 19.4697 4.40298C18.9734 4.00021 18.247 3.75 17.3889 3.75H7C6.58579 3.75 6.25 3.41421 6.25 3Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 8.5C2.25 7.25736 3.25736 6.25 4.5 6.25H15.5C16.7426 6.25 17.75 7.25736 17.75 8.5V19.5C17.75 20.7426 16.7426 21.75 15.5 21.75H4.5C3.25736 21.75 2.25 20.7426 2.25 19.5V8.5ZM4.5 7.75C4.08579 7.75 3.75 8.08579 3.75 8.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H15.5C15.9142 20.25 16.25 19.9142 16.25 19.5V8.5C16.25 8.08579 15.9142 7.75 15.5 7.75H4.5Z",
    fill: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.85b8d1d1d0446d7b2815cdf83116a36d.svg";
export { ForwardRef as ReactComponent };